import { useState } from "react"
import { toast } from "react-toastify";
import axios from "axios";
import { useGlobalContext } from '../Context/Authentation';

export default function AddNotesModel() {
    const { user, setrefresh, refresh } = useGlobalContext();
    const [title, settitle] = useState("");
    const [content, setcontent] = useState("");

    const SubmitHandler = async () => {
        if (!content || !title) {
            toast.warn('Please enter blank fileds', {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            return;
        }
        var toast1;
        try {
            toast1 = toast.loading("Creating Note", {
                position: "bottom-center",
                theme: "dark",
            })

            const config = { headers: { Authorization: `Bearer ${user?.token}` } }
            await axios.post(`https://quick-notes-c09v.onrender.com/api/notes`, { title: title, content: content }, config);
            settitle("Enter your Title")
            setcontent("")


            toast.update(toast1,
                {
                    render: "New note created",
                    type: "success",
                    isLoading: false,
                    position: "bottom-center",
                    autoClose: 5000,
                    theme: "dark",
                    closeOnClick: true,
                });

        } catch (error) {
            console.log(error);
            toast.update(toast1,
                {
                    render: "Unable to make new Note",
                    type: "error",
                    isLoading: false,
                    position: "bottom-center",
                    autoClose: 5000,
                    theme: "dark",
                    closeOnClick: true,
                });
        }
        setrefresh(!refresh)
    }

    return (
        <div className="modal fade" id="addnewNotes" tabIndex="-1" aria-labelledby="addnewNotesLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5 text" id="addnewNotesLabel" style={{ color: "black" }}>Add New Note</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <input type="text" className="form-control" placeholder="Enter your Title" value={title} onChange={(e) => { settitle(e.target.value) }} />
                        <textarea type="text" className="form-control mt-2" placeholder='Type Something...' rows="5" value={content} onChange={(e) => { setcontent(e.target.value) }} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" data-bs-dismiss="modal" className="btn btn-primary" onClick={SubmitHandler}>Add Note</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
